
import { ShiftTeamTypeModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { Guid } from '@/libs/common/functions/guid';
import { shiftTeamTypesStore } from '@/libs/shift-team-types/+state/store';
import ShiftTeamTypeDialog from '@/libs/settings/components/ShiftTeamTypeDialog.vue';

@Component({
    components: {
        ShiftTeamTypeDialog,
    },
})
export default class ShiftTeamTypes extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('shiftTeamTypes.code'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('shiftTeamTypes.name'), value: 'name', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: ShiftTeamTypeDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return shiftTeamTypesStore.useGetter(CrudGetter.Pending);
    }

    get shiftTeamTypes(): ShiftTeamTypeModel[] {
        return [...shiftTeamTypesStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...shiftTeamTypesStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        shiftTeamTypesStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<ShiftTeamTypeModel>(
            [
                { field: 'code', index: 1, order: 'asc' },
                { field: 'name', index: 2, order: 'asc' },
            ],
            this.getFilters()
        );
    }

    open(item: ShiftTeamTypeModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
